import { useFeatureFlagEnabled } from '@posthog/react'
import { POSTHOG_FEATURE_FLAGS } from '../PostHog/index'

export const DIVINATION_COHORT_FLAGS = [
  POSTHOG_FEATURE_FLAGS.AI_DIVINATION_A,
  POSTHOG_FEATURE_FLAGS.AI_DIVINATION_B,
  POSTHOG_FEATURE_FLAGS.AI_DIVINATION_C,
  POSTHOG_FEATURE_FLAGS.AI_DIVINATION_D,
] as const

export const useIsDivinationCohort = (): {
  isDivinationCohort: boolean
  cohort: string | null
} => {
  // Hooks must be called unconditionally
  const a = useFeatureFlagEnabled(DIVINATION_COHORT_FLAGS[0])
  const b = useFeatureFlagEnabled(DIVINATION_COHORT_FLAGS[1])
  const c = useFeatureFlagEnabled(DIVINATION_COHORT_FLAGS[2])
  const d = useFeatureFlagEnabled(DIVINATION_COHORT_FLAGS[3])

  const results = [a, b, c, d]
  const enabledIndex = results.findIndex(Boolean)

  return {
    isDivinationCohort: enabledIndex !== -1,
    cohort: enabledIndex !== -1 ? DIVINATION_COHORT_FLAGS[enabledIndex] : null,
  }
}
